var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisputeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Strokes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #02025b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.992086,170.298845c0-26.74037,21.677618-48.417984,48.417984-48.417984s48.417984,21.677614,48.417984,48.417984c0,0-18.935544,4.405382-48.033741,4.405382-29.587792,0-48.802227-4.405382-48.802227-4.405382Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 70.410069,
    cy: 95.642072,
    r: 23.948792
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.030111,155.132232s-2.572504-5.58434-6.502188-10.7456c-3.105193-4.078371-11.510724-13.101842-11.510724-13.101842,6.401358-10.487107,20.276646-16.196747,33.462104-16.196747,20.132501,0,36.45332,16.320815,36.45332,36.45332,0,0-29.631424,6.499935-51.902512,3.59087Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 131.944232,
    cy: 93.447701,
    r: 18.823183
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.752954,12.540165h45.268247c2.901145,0,5.252954,2.296574,5.252954,5.129456v34.152733c0,2.832938-2.35181,5.129512-5.252954,5.129512h-6.084962s.020247,16.390825.020247,16.390825l-23.574411-16.390825H7.752954c-2.901145,0-5.252954-2.296574-5.252954-5.129512V17.669621c0-2.832882,2.35181-5.129456,5.252954-5.129456Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.262069,40.569555s.216538-3.147959,2.15479-4.696824c4.047703-3.234537,5.675104-4.582712,5.898964-7.192005.217633-2.53671-1.551066-6.016179-5.47697-6.647771-4.010132-.645142-8.506164,1.647589-9.004423,6.804682l-1.01893-.129693c0-5.335886,4.831773-8.493874,10.384661-7.66458,5.050265.75423,7.191337,5.144292,6.640362,8.094819-.532285,2.85044-.962894,3.249759-5.756297,6.635547-.391091.276244-1.755444,1.199376-2.180385,2.159427-.437581.988608-.516765,2.636398-.516765,2.636398h-1.125008Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.908768,
    cy: 47.963532,
    r: 0.862983
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.247046,5.295773h-45.268247c-2.901145,0-5.252954,2.296574-5.252954,5.129456v34.152733c0,2.832938,2.35181,5.129512,5.252954,5.129512h6.084962l-.020247,16.390825,23.574411-16.390825h15.629121c2.901145,0,5.252954-2.296574,5.252954-5.129512V10.42523c0-2.832882-2.35181-5.129456-5.252954-5.129456Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 148.848332,
    cy: 15.844755,
    r: 1.046487
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 148.31705,
    y: 23.883323,
    width: 0.833851,
    height: 15.921753,
    rx: 0.068491,
    ry: 0.068491
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeNew);
export default __webpack_public_path__ + "static/media/dispute_new.add91fcd02ff9b7d859d434c99f50b42.svg";
export { ForwardRef as ReactComponent };